<template>
  <span>
    <span
      v-if="currentPosition && currentPosition.attributes.battery &&
        (currentPosition.attributes.battery > 5 || currentPosition.protocol === 'rst')"
      style="padding-right: 4px"
    >
      <el-tooltip :content="currentPosition.attributes.battery.toFixed(2) + 'V'">
        <i
          :class="'fas fa-battery-' + icon(batteryToPercentage(currentPosition.attributes.battery))"
          :style="'color: ' + color(batteryToPercentage(currentPosition.attributes.battery))"
        ></i>
      </el-tooltip>
      <span v-if="currentPosition.protocol === 'rst'"> {{ batteryToPercentage(currentPosition.attributes.battery) }}%</span>
    </span>
    <span v-if="currentPosition && currentPosition.attributes.temp1 && currentPosition.attributes.temp1 !== 175 && currentPosition.attributes.temp1 !== 3000">
      <el-tooltip :content="'Temp. 1: ' + currentPosition.attributes.temp1.toFixed(1) + 'ºC'">
        <i class="fas fa-thermometer-quarter rpmIcon" style="padding-left:2px"></i>
      </el-tooltip>{{ currentPosition.attributes.temp1.toFixed(1) }}ºC
    </span>
    <span v-if="currentPosition && currentPosition.attributes.temp2 && currentPosition.attributes.temp2 !== 175 && currentPosition.attributes.temp2 !== 3000">
      <el-tooltip :content="'Temp. 2: ' + currentPosition.attributes.temp2.toFixed(1) + 'ºC'">
        <i class="fas fa-thermometer-quarter rpmIcon" style="padding-left:2px"></i>
      </el-tooltip>{{ currentPosition.attributes.temp2.toFixed(1) }}ºC
    </span>
    <span v-if="currentPosition && currentPosition.attributes.temp3 && currentPosition.attributes.temp3 !== 175 && currentPosition.attributes.temp3 !== 3000">
      <el-tooltip :content="'Temp. 3: ' + currentPosition.attributes.temp3.toFixed(1) + 'ºC'">
        <i class="fas fa-thermometer-quarter rpmIcon" style="padding-left:2px"></i>
      </el-tooltip>{{ currentPosition.attributes.temp3.toFixed(1) }}ºC
    </span>
    <span v-if="currentPosition && currentPosition.attributes['coolantTemp']">
      <el-tooltip :content="currentPosition && currentPosition.attributes['coolantTemp'] + '°C'">
        <i class="fa-duotone fa-oil-temperature" style="color:#3D993D"></i>
      </el-tooltip> {{ currentPosition && currentPosition.attributes['coolantTemp'] + '°C' }}
    </span>
    <span v-if="currentPosition && currentPosition.attributes['humidity1']">
      <el-tooltip :content="'Hm 1: ' + (currentPosition && currentPosition.attributes['humidity1']) + '%'">
        <i class="fa-duotone fa-droplet-percent" style="color:#3D993D"></i>
      </el-tooltip> {{ currentPosition && currentPosition.attributes['humidity1'] + '%' }}
    </span>
    <span v-if="currentPosition && currentPosition.attributes['humidity2']">
      <el-tooltip :content="'Hm 2: ' + (currentPosition && currentPosition.attributes['humidity2']) + '%'">
        <i class="fa-duotone fa-droplet-percent" style="color:#3D993D"></i>
      </el-tooltip> {{ currentPosition && currentPosition.attributes['humidity2'] + '%' }}
    </span>
  </span>
</template>

<script>
export default {
  name: 'TemperatureIcons',
  props: {
    device: {
      type: Object,
      default: () => {}
    },
    currentPosition: {
      type: Object,
      default: () => {}
    }
  },
  methods: {
    color: battery => battery < 10 ? 'red' : (battery < 50 ? 'orange' : 'green'),
    icon: battery => battery < 10 ? 'slash' : (battery < 50 ? 'half' : 'full'),
    batteryToPercentage(v) {
      if (v > 5) {
        return v < 6.6 ? 9 : (v < 7 ? 49 : 100)
      } else {
        const vMin = 3.60
        const vMax = 4.10
        let pct = ((v - vMin) / (vMax - vMin)) * 100
        if (pct < 0) pct = 0
        if (pct > 100) pct = 100
        return Math.round(pct)
      }
    }
  }
}
</script>
